<template>
  <div class="user-bar">
    <i class="glyphicon glyphicon-menu-hamburger" @click="toggleDropdown"></i>
    <div class="user-bar__name" @click="toggleDropdown">
      <img v-if="!connectionState" class="user-bar__offline" :src="`${publicPath}assets/images/offline.svg`" alt="">
      {{ userName }}
    </div>
    <transition name="user-bar__list-wrap-anim">
      <ul v-show="dropdownOpened" class="dropdown-menu">
        <li class="user-bar__username" :title="$t('userBar.userPreferences')">
          <router-link to="/user">{{ userName }}&nbsp;<i class="glyphicon glyphicon-cog"></i></router-link>
        </li>

        <li>
          <hr>
        </li>
        <li>
          <router-link to="/events">{{ translate('userBar.events') }}</router-link>
        </li>
        <li>
          <router-link to="/crews">{{ translate('userBar.crews') }}</router-link>
        </li>
        <li>
          <router-link to="/map">{{ translate('userBar.map') }}</router-link>
        </li>
        <li>
          <router-link to="/hospitals">{{ translate('userBar.hospitals') }}</router-link>
        </li>
        <li>
          <router-link to="/scenarios">{{ translate('userBar.scenarios') }}</router-link>
        </li>
        <!--<li>
            <router-link to="/evaluation">{{translate('userBar.evaluation)}}</router-link>
        </li>-->
        <li>
          <router-link to="/log">{{ translate('userBar.log') }}</router-link>
        </li>
        <li v-if="hideSpecificUser === false">
          <router-link :to="`/scenario${simId ? ('/'+simId) : ''}`">{{ translate('userBar.scenarioSettings') }}
          </router-link>
        </li>
        <!--<li>
            <router-link to="/log">{{translate('userBar.log)}}</router-link>
        </li>-->

        <li v-if="isAdmin">
          <hr>
        </li>
        <li v-if="isAdmin">
          <router-link to="/admin#users">{{ translate('userBar.usersAdministration') }}</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link to="/admin#organizations">{{ translate('userBar.groupsAdministration') }}</router-link>
        </li>
        <li v-if="isAdmin">
          <router-link to="/admin#qanda">{{ translate('userBar.qandaAdministration') }}</router-link>
        </li>
        <li>
          <hr>
        </li>
        <li @click="logout"><a>{{ translate('userBar.logout') }} <i class="glyphicon glyphicon-log-out"></i></a></li>
      </ul>
    </transition>
  </div>
</template>

<script>

export default {
  name: "userBar",
  data() {
    return {
      dropdownOpened: false,
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    toggleDropdown() {
      if (this.dropdownOpened === false) {
        this.dropdownOpened = true;
      }
      else {
        this.dropdownOpened = false;
      }
    },
    async logout() {
      await this.$store.dispatch('logout');
    }
  },
  computed: {
    userName() {
      if (!this.$store.state.auth.user) {
        return this.translate('userBar.noUser');
      }
      return this.$store.state.auth.user.email;
    },
    connectionState() {
      return this.$store.state.online;
    },
    isAdmin() {
      return this.$store.state.auth.user.isAdmin;
    },
    hideSpecificUser() {
      return this.userName === 'prez@zzshmp.cz';
    },
    simId() {
      return this.$store.state.scenarioSelectedId
    }
  },


}
</script>

<style lang="less" scoped>
.user-bar {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-content: center;
  //background-color: #9d9f9e;
  position: fixed;
  top: 4px;
  right: 4px;
  cursor: pointer;
  z-index: 10000;

  .glyphicon-menu-hamburger {
    color: #9d9f9e;
    display: block;
    font-size: 14px;
    line-height: 25px;
  }

  ul {
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    display: block;
    user-select: none;
    cursor: auto;

    li {
      padding: 3px 5px;

      .glyphicon {
        font-size: 12px;
      }

      a {
        padding: 0;
        cursor: pointer;
      }

      select {
        width: 100%;
        height: 32px;
        background-color: #9d9f9e;
        color: white;
      }

      hr {
        margin: 2px;
      }
    }
  }

  &__name {
    position: absolute;
    top: 1px;
    right: 25px;
    text-align: right;
    color: #9d9f9e;
    font-weight: bold;
  }

  &__username {
    color: #1b1e21;
    font-weight: 700;
  }

  &__list-wrap-anim {
    &-enter-active,
    &-leave-active {
      transition: opacity .3s;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }
  }

  &__offline {
    position: absolute;
    left: -26px;
    top: 1px;
    width: 20px;
  }
}
</style>
